module.exports = __webpack_public_path__ + "img/full-profile-place-icon.2a8a17e0.svg";